import { useCallback, useEffect, useRef, useState } from 'react';

import { Button } from 'antd';

import Ai from './icons/Ai';

export const NiceActions = ({
  onAIGenerate,
  onClear,
  iaText = 'Reescrever com IA',
  clearText = 'Apagar texto'
}: {
  onAIGenerate?: () => void;
  onClear?: () => void;
  iaText?: string;
  clearText?: string;
}) => {
  const [generating, setIsGenerating] = useState(false);

  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fakeIaLoad = useCallback(() => {
    setIsGenerating(true);
    setTimeout(
      () => {
        if (!mountedRef.current || !onAIGenerate) {
          return;
        }

        setIsGenerating(false);

        onAIGenerate();
      },
      Math.ceil(Math.random() * 500 + 1000)
    );
  }, [onAIGenerate, setIsGenerating]);

  if (!onAIGenerate && !onClear) {
    return null;
  }

  return (
    <div className='flex flex-row gap-2'>
      {onAIGenerate && (
        <Button
          id='rewrite-with-ia'
          loading={generating}
          disabled={generating}
          className='border-ai-with-bg-surface-default! border! border-solid!'
          size='middle'
          icon={<Ai className='h-4 w-4' />}
          onClick={() => fakeIaLoad()}
        >
          {iaText}
        </Button>
      )}
      {onClear && (
        <Button id='clear' variant='filled' color='default' type='default' size='middle' onClick={() => onClear()}>
          {clearText}
        </Button>
      )}
    </div>
  );
};
